import React, { useContext } from "react";
import { ReactReduxContext } from "react-redux";
import clsx from "clsx";
import PropTypes from 'prop-types';
import { getPages, getPagesCount } from "./TablePaginationHelpers";
import IconButton from "../../IconButton/IconButton";
import { Localize as AriaLocalize } from "../../../../shared/ariaLabelLocalize";

const PaginationLinks = ({ paginationProps }) => {
  const reduxContext = useContext(ReactReduxContext);
  const ariaLangId = reduxContext?.store?.getState()?.language?.selectedlanguage?.id;
  const t = AriaLocalize[ariaLangId] || AriaLocalize['en_US'];
  const {
    totalSize,
    sizePerPage,
    page: pageNumber,
    paginationSize,
  } = paginationProps;
  const pagesCount = getPagesCount(totalSize, sizePerPage);
  const pages = getPages(pageNumber, pagesCount, paginationSize);
  const handleFirstPage = ({ onPageChange }) => {
    onPageChange(1);
  };

  const handlePrevPage = ({ page, onPageChange }) => {
    onPageChange(page - 1);
  };

  const handleNextPage = ({ page, onPageChange }) => {
    if (page < pagesCount) {
      onPageChange(page + 1);
    }
  };

  const handleLastPage = ({ onPageChange }) => {
    onPageChange(pagesCount);
  };

  const handleSelectedPage = ({ onPageChange }, pageNum) => {
    onPageChange(pageNum);
  };

  const isFirstDisabled = pageNumber === 1;
  const isLastDisabled = pageNumber === pagesCount;

  const navButtonClass = "btn btn-outline-secondary btn-pagi-icon";
  return (
    <>
      {pagesCount < 2 && <></>}
      {pagesCount > 1 && (
        <nav aria-label={t.pagination} className="d-flex flex-wrap tbl-pagination">
          <IconButton
            data-testid="FirstButton"
            ariaLabel={t.first_page}
            onClick={() => handleFirstPage(paginationProps)}
            disabled={isFirstDisabled}
            className={clsx(navButtonClass, isFirstDisabled && "disabled")}
            iconClass="icon-previous-free btn-icon"
          />
          <IconButton
            data-testid="PreviousButton"
            ariaLabel={t.previous_page}
            onClick={() => handlePrevPage(paginationProps)}
            disabled={isFirstDisabled}
            className={clsx(navButtonClass, isFirstDisabled && "disabled")}
            iconClass="icon-previous btn-icon"
          />

          {pageNumber > 1 && <div className="more-page-label">...</div>}
          {pages.map((p) => {
            const isActive = pageNumber === p;
            return (
              <button
                key={p}
                type="button"
                data-testid={"page" + p}
                onClick={() => handleSelectedPage(paginationProps, p)}
                aria-current={isActive ? "page" : undefined}
                aria-label={(isActive ? t.page_current : t.go_to_page).replace('{n}', p)}
                className={`btn btn-outline-secondary btn-mob-hide ${
                  isActive ? " active" : ""
                } `}
              >
                {p}
              </button>
            );
          })}
          {pageNumber < pagesCount && (
            <div className="more-page-label">...</div>
          )}
          <IconButton
            data-testid="NextButton"
            ariaLabel={t.next_page}
            onClick={() => handleNextPage(paginationProps)}
            disabled={isLastDisabled}
            className={clsx(navButtonClass, isLastDisabled && "disabled")}
            iconClass="icon-next btn-icon"
          />
          <IconButton
            data-testid="LastButton"
            ariaLabel={t.last_page}
            onClick={() => handleLastPage(paginationProps)}
            disabled={isLastDisabled}
            className={clsx(navButtonClass, isLastDisabled && "disabled")}
            iconClass="icon-next-free btn-icon"
          />
        </nav>
      )}
    </>
  );
};

PaginationLinks.propTypes = {
  paginationProps: PropTypes.object,
};

export default PaginationLinks;
